<template>
  <div class="app-wrapper">
    <div id="app"
      :class="$route.name"
    >
      <transition name="page">
        <router-view
          v-if="!usePortrait"
          :bg-image="`${publicPath}/img/landscape-4032192_1920.jpg`"
        />
      </transition>
      <transition name="page">
        <UsePortraitScreen
          class="view" v-if="usePortrait"
        ></UsePortraitScreen>
      </transition>
    </div>
  </div>
</template>

<script>
import 'browser-report'

export default {
  name: 'app',

  data () {
    return {
      usePortrait: false,
      publicPath: process.env.VUE_APP_BASE_URL
    }
  },

  computed: {
    siteId () {
      return process.env.VUE_APP_SITE_ID
    },
    surveyId () {
      return process.env.VUE_APP_DEFAULT_SID
    },
    routeName () {
      return this.$route.name
    },
    qid () {
      return this.$route.params.qid
    }
  },

  components: {
    UsePortraitScreen: () => import('Components/base/UsePortraitScreen')
  },

  methods: {
    loadSite () {
      if (this.siteId) {
        this.$store.dispatch('LOAD_NEW_SITE', { siteId: this.siteId })
      }
      if (this.surveyId) {
        this.$store.dispatch('LOAD_NEW_SURVEY', { surveyId: this.surveyId })
      }
    },
    /*
     * Detect orientation and disable horizontal orientation for smartphones and small tablets
     */
    detectOrientation () {
      if (window.screen.height < window.screen.width && window.screen.height < 600) {
        this.usePortrait = true
      } else {
        this.usePortrait = false
      }
    }
  },

  mounted () {
    /*
     * Add a browser report. TODO: check if there's a better package that works with the Brave browser.
     */
    // eslint-disable-next-line
    browserReport((err, report) => {
      if (err) {
        throw err
      }
      this.$store.commit('BROWSER_REPORT', { report: report })
    })

    /*
     * Add detectOrientation listener.
     */
    this.detectOrientation()
    window.addEventListener('resize', this.detectOrientation)

    /*
     * Load website on mounted.
     */
    this.loadSite()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.detectOrientation)
  },
  watch: {
    'qid': function (newVal) {
      this.$store.commit('SET_ACTUAL_QID', { qid: parseInt(newVal, 10) })
      this.$store.commit('SET_CURRENT', { current: parseInt(newVal, 10) })
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
  background-size: cover;
  background-position: center center;
  min-width: 100vw;

  &.not-found {
    background-color: #F5F4F0;
    height: 100vh;
    display: flex;
  }
}

.app-wrapper {
  min-height: 100vh;
}

</style>
